import { Directive, HostListener, ElementRef, Input} from '@angular/core';
declare var $: any;

@Directive({
  selector: '[telefone]'
})
export class TelefoneDirective {
  private el: HTMLInputElement

  @Input() celular: boolean = false;

  constructor(private ref: ElementRef) {
    this.el = this.ref.nativeElement;
  }

  // @HostListener('keyup', ['$event.target.value'])
  // onKeyup(value: any) {
  //   let numbers = value && value.replace(/-/g,"");
  //   let matches;
  //   if(value.length < 3) {
  //     matches = numbers && numbers.match(/^(\d{2})$/);
  //     if(matches) {
  //         this.el.value = "(" + matches[1] + ")";
  //     }
  //   } else {
  //     numbers = numbers && numbers.replace(/[^0-9]/g,"");
  //     matches = numbers && numbers.match(/^(\d{2})(\d?\d{4})(\d{4})$/);
  //     if(matches) {
  //       this.el.value = "(" + matches[1] + ")" + matches[2] + "-" + matches[3];
  //     }
  //   }
  // }

  // @HostListener('blur', ['$event.target.value'])
  // onBlur(value: any) {
  //   if (value.length === this.el.value.length) {
  //     return;
  //   }
  //   this.el.value = '';
  // }

  @HostListener('focus', ['$event'])
  onFocus(event: any) {
    let element;
    element = $(this.el);
    element.unmask();
    element.mask("(99) 99999-9999");
  }

  @HostListener('focusout', ['$event'])
  onFocusout(event: any) {
    let phone;
    let element;
    element = $(this.el);
    element.unmask();

    if(this.celular){
      element.mask("(99) 99999-9999");
    }else{
      phone = element.val().replace(/\D/g, '');

      if(phone.length > 10) {
        element.mask("(99) 99999-9999");
      } else {
        element.mask("(99) 9999-99999");
      }
    }
  }

  @HostListener('keypress', ['$event'])
  onkeypress(event) {
    let keyCode = event.which;
    let ShiftPress = event.shiftKey;
    let CtrlPress  = event.ctrlKey;
    let type = event.type;
    let keyCodesDownPermitidos: Array<number>;

     if((!ShiftPress) && (type == "keypress")){

       if($.atsjs.prototype._isfirefox()){
         keyCodesDownPermitidos = new Array(8,9,13,37,39,46);
       }else{
         keyCodesDownPermitidos = new Array();
         keyCodesDownPermitidos.push(13);
       }

       let keyCodesPermitidos = new Array();

        //numeros e 0 a 9 do teclado alfanumerico
        for(let x=48;x<=57;x++){
            keyCodesPermitidos.push(x);
        }

        //Verifica se a tecla digitada é permitida
        if (((!ShiftPress) && (!CtrlPress) && ($.inArray(event.keyCode,keyCodesDownPermitidos) != -1)) || ($.inArray(keyCode,keyCodesPermitidos) != -1)){
          return true;
        }else{
          return false;
        }
    }else{
      if($.atsjs.prototype._isfirefox()){
        if((ShiftPress) && (event.keyCode == 9)){
          return true;
        }else{
          return false;
        }
      }else{
        return false;
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/util/directives/telefone.directive.ts